module.exports = __webpack_public_path__ + "img/logo-ugm.c34f3fa2.png";